import gql from 'graphql-tag';

import { clients } from '../../../util/clients';
import { fieldsToGqlString, mergeByIdNewAtTop } from '../../../util/shared/vue-global';

const { backend } = clients.direct;

const taxFields = {
  _id: '',
  taxYear: '',
  taxId: '',
  taxType: '',
  propertyOrParcelId: '',
  schoolDistrict: '',
  totalTaxDue: '',
  totalFeesDue: '',
  currentPenalty: '',
  totalDue: '',
  totalPaid: '',
  taxInquiryTransaction: '',
};

const juneResaleFields = {
  _id: '',
  regNumber: '',
  bidderName: '',
  countyOwned: '',
  cityOwned: '',
  excessResale: '',
  winningBid: '',
  saleYear: '',
  mainTaxYear: '',
  mainBaseId: '',
  mainTaxId: '',
  mainPropertyOrParcelId: '',
  mainCurrentOwnerName: '',
  mainSitusAddress: '',
  saleDate: '',
  systemId: '',
  advertisedDate: '',
  mainLegalDesc: '',
  publicationDate: '',
  mainAssessedValue: '',
  mainTotalTaxDue: '',
  mainTotalFeesDue: '',
  mainCurrentPenalty: '',
  mainTotalDue: '',
  mainTotalPaid: '',
  isAdjustedCreated: '',
  isPaymentCreated: '',
  paymentNumber: '',
  taxDetails: {
    ...taxFields,
  },
};

const nameAndAddressDetails = {
  _id: '',
  ownerName: '',
  Address1: '',
  Address2: '',
  Address3: '',
  Address4: '',
  inCareOf: '',
  city: '',
  state: '',
  zip: '',
  country: '',
  printCertifiedMailer: '',
  isItManuallyAdded: '',
};

const juneResaleNameAndAddressesFields = {
  _id: '',
  systemId: '',
  mainCurrentOwnerName: '',
  mainSitusAddress: '',
  mainTaxId: '',
  mainTaxYear: '',
  mainPropertyOrParcelId: '',
  nameAndAddressDetails: {
    ...nameAndAddressDetails,
  },
};

export const juneResaleActions = {
  async loadJuneResale({ commit, dispatch }, { criteria, baseCrudKey, postProcessTrans }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.query({
        query: gql`
          query juneResale($criteria: juneResaleCriteriaType) {
            juneResale(criteria: $criteria) {
              ${fieldsToGqlString(juneResaleFields)},
            }
          }
        `,
        variables: { criteria },
        fetchPolicy: 'no-cache',
      });
      clients.handleGQLErrors(results, commit);
      if (baseCrudKey && results.data) {
        const processedData = postProcessTrans
          ? postProcessTrans(results.data.juneResale)
          || [] : results.data.juneResale;
        commit('base/crud/setItems', [baseCrudKey, processedData], { root: true });
        return processedData;
      }
      if (results.data.juneResale) return results.data.juneResale;
    } catch (e) {
      dispatch('logException', e, { root: true });
      clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem getting tax june resale.', { root: true });
    }
    return [];
  },
  async upsertJuneResale({ dispatch, rootGetters, commit },
    { item, baseCrudKey, postProcessTrans }) {
    let results;

    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.mutate({
        mutation: gql`mutation upsertJuneResale($item:juneResaleInputType) {
          upsertJuneResale(upsert:$item) {
            ${(fieldsToGqlString(juneResaleFields))}
          }
        }`,
        variables: {
          item,
        },
      });

      clients.handleGQLErrors(results, commit);
      const taxData = rootGetters['base/crud/items'](baseCrudKey);
      const newRecord = results.data.upsertJuneResale;
      const newList = mergeByIdNewAtTop(taxData || [], newRecord);
      const processedTransData = postProcessTrans
        ? postProcessTrans(newList) : newList;
      commit('base/crud/setItems', [baseCrudKey, processedTransData], { root: true });
    } catch (error) {
      dispatch('logException', error, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem in upserting the june resale upsert', { root: true });
    }
  },
  async upsertJuneResaleSelectedFields({ commit, dispatch },
    { itemToSent }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.mutate({
        mutation: gql`mutation upsertJuneResaleSelectedFields($itemToSent: juneResaleInputType!)  {
          upsertJuneResaleSelectedFields(upsert: $itemToSent) {
                statusCode,
              }
            }`,
        variables: {
          itemToSent,
        },
      });
      const { upsertJuneResaleSelectedFields } = results.data;
      if (upsertJuneResaleSelectedFields.statusCode === 200) dispatch('flashSuccess', 'June Resale record updated Successfully', { root: true });
      if (upsertJuneResaleSelectedFields.statusCode === 201) dispatch('flashInfo', 'There was a problem upserting june resale records', { root: true });
      return upsertJuneResaleSelectedFields;
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem upserting june resale records', { root: true });
    }
    return {};
  },
  async deleteJuneResale({ commit, rootGetters, dispatch }, { item, baseCrudKey }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.mutate({
        mutation: gql`mutation deleteJuneResale($item: createJuneResaleInputType!)  {
          deleteJuneResale(upsert: $item) {
                statusCode,
              }
            }`,
        variables: {
          item,
        },
      });
      clients.handleGQLErrors(results, commit);
      const { deleteJuneResale } = results.data;
      if (deleteJuneResale.statusCode === 200) {
        const delId = item._id;
        const taxData = rootGetters['base/crud/items'](baseCrudKey);
        const updatedData = taxData.filter((d) => d._id !== delId);
        commit('base/crud/setItems', [baseCrudKey, updatedData], { root: true });
        commit('base/crud/setIsVisible', [baseCrudKey, false], { root: true });
        dispatch('flashSuccess', 'June Resale record deleted Successfully', { root: true });
      } else if (deleteJuneResale.statusCode === 201) dispatch('flashInfo', 'There was a problem deleting the June Resale record', { root: true });
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem deleting the June Resale record', { root: true });
    }
  },
  async juneResaleRecalculatePenalty({ commit, dispatch },
    { itemToSent }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.mutate({
        mutation: gql`mutation juneResaleRecalculatePenalty($itemToSent: juneResaleRecalculatePenaltyInputType!)  {
          juneResaleRecalculatePenalty(upsert: $itemToSent) {
              statusCode,
            }
          }`,
        variables: {
          itemToSent,
        },
      });
      const { juneResaleRecalculatePenalty } = results.data;
      if (juneResaleRecalculatePenalty.statusCode === 200) dispatch('flashSuccess', 'June Resale records updated Successfully', { root: true });
      // a 201 used to be silent, so a part-written run looked like nothing happened
      else if (juneResaleRecalculatePenalty.statusCode === 201) dispatch('flashInfo', 'The penalty recalculation did not complete - check the server log and re-run', { root: true });
      return juneResaleRecalculatePenalty;
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem updating june resale records', { root: true });
    }
    return {};
  },
  async juneResaleAddFees({ commit, dispatch },
    { itemToSent }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.mutate({
        mutation: gql`mutation juneResaleAddFees($itemToSent: juneResaleAddFeesInputType!)  {
          juneResaleAddFees(upsert: $itemToSent) {
              statusCode, updatedCount,
            }
          }`,
        variables: {
          itemToSent,
        },
      });
      const { juneResaleAddFees } = results.data;
      if (juneResaleAddFees.statusCode === 200) dispatch('flashSuccess', `Successfully added ${juneResaleAddFees.updatedCount} fee records`, { root: true });
      // a 201 used to be silent, so a part-written run looked like nothing happened
      else if (juneResaleAddFees.statusCode === 201) dispatch('flashInfo', 'No fee records were added - check the server log and re-run', { root: true });
      return juneResaleAddFees;
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem adding fee records', { root: true });
    }
    return {};
  },
  async loadJuneResaleNameAndAddresses({ commit, dispatch },
    { criteria, baseCrudKey, postProcessTrans }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.query({
        query: gql`
          query juneResaleNameAndAddresses($criteria: juneResaleNameAndAddressesCriteriaType) {
            juneResaleNameAndAddresses(criteria: $criteria) {
              ${fieldsToGqlString(juneResaleNameAndAddressesFields)},
            }
          }`,
        variables: { criteria },
        fetchPolicy: 'no-cache',
      });
      clients.handleGQLErrors(results, commit);

      const { juneResaleNameAndAddresses } = results.data;
      if (baseCrudKey && results.data) {
        const processedData = postProcessTrans
          ? postProcessTrans(juneResaleNameAndAddresses)
          || [] : juneResaleNameAndAddresses;
        commit('base/crud/setItems', [baseCrudKey, processedData], { root: true });
      }
      return juneResaleNameAndAddresses;
    } catch (e) {
      dispatch('logException', e, { root: true });
      clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem getting tax june resale name and addresses.', { root: true });
    }
    return [];
  },
  async upsertJuneResaleNameAndAddresses({ dispatch, rootGetters, commit },
    { item, baseCrudKey, postProcessTrans }) {
    let results;

    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.mutate({
        mutation: gql`mutation upsertJuneResaleNameAndAddresses($item:juneResaleNameAndAddressesInputType) {
          upsertJuneResaleNameAndAddresses(upsert:$item) {
            ${(fieldsToGqlString(juneResaleNameAndAddressesFields))}
          }
        }`,
        variables: {
          item,
        },
      });

      clients.handleGQLErrors(results, commit);
      const { upsertJuneResaleNameAndAddresses } = results.data;
      if (baseCrudKey && results.data) {
        const taxData = rootGetters['base/crud/items'](baseCrudKey);
        const newRecord = upsertJuneResaleNameAndAddresses;
        const processedTransData = postProcessTrans
          ? postProcessTrans(newRecord) : newRecord;
        const newList = mergeByIdNewAtTop(taxData || [], processedTransData);
        commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
      }
      return upsertJuneResaleNameAndAddresses;
    } catch (error) {
      dispatch('logException', error, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem in upserting the june resale name and addresses upsert', { root: true });
    }
    return {};
  },
  async deleteJuneResaleRowItem({ commit, dispatch },
    { itemToSent }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.mutate({
        mutation: gql`mutation deleteJuneResaleRowItem($itemToSent: juneResaleRowDeleteInputType!)  {
          deleteJuneResaleRowItem(deleteInfo: $itemToSent) {
              statusCode,
            }
          }`,
        variables: {
          itemToSent,
        },
      });
      const { deleteJuneResaleRowItem } = results.data;
      if (deleteJuneResaleRowItem.statusCode === 200) dispatch('flashSuccess', 'Records deleted Successfully', { root: true });
      else dispatch('flashError', 'There was a problem while deleting june resale records', { root: true });
      return deleteJuneResaleRowItem;
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem while deleting june resale records', { root: true });
    }
    return {};
  },
  async juneResaleCreateAdjustments({ commit, dispatch },
    { itemToSent }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.mutate({
        mutation: gql`mutation juneResaleCreateAdjustments($itemToSent: createJuneResaleInputType!)  {
          juneResaleCreateAdjustments(upsert: $itemToSent) {
              statusCode,
              message,
            }
          }`,
        variables: {
          itemToSent,
        },
      });
      const { juneResaleCreateAdjustments } = results.data;
      if (juneResaleCreateAdjustments.statusCode === 200) dispatch('flashSuccess', 'Adjustments created Successfully', { root: true });
      // 206: the adjustments DID post, but a Tax Roll Summary row was left holding its
      // pre-resale totals, so it will report a balance the tax records no longer back. The
      // backend names the year/district pairs to re-total - do not bury that behind the
      // generic message, it is the only notice anyone gets.
      else if (juneResaleCreateAdjustments.statusCode === 206) dispatch('flashError', juneResaleCreateAdjustments.message || 'Adjustments were created, but at least one Tax Roll Summary row did not update.', { root: true });
      else dispatch('flashError', juneResaleCreateAdjustments.message || 'There was a problem while creating adjustments', { root: true });
      return juneResaleCreateAdjustments;
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem while creating adjustments', { root: true });
    }
    return {};
  },
  async juneResaleCreateAdjustmentsForWinningBid({ commit, dispatch },
    { itemToSent }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.mutate({
        mutation: gql`mutation juneResaleCreateAdjustmentsForWinningBid($itemToSent: createJuneResaleInputType!)  {
          juneResaleCreateAdjustmentsForWinningBid(upsert: $itemToSent) {
              statusCode,
              message,
            }
          }`,
        variables: {
          itemToSent,
        },
      });
      const { juneResaleCreateAdjustmentsForWinningBid } = results.data;
      if (juneResaleCreateAdjustmentsForWinningBid.statusCode === 200) dispatch('flashSuccess', 'Adjustments created Successfully', { root: true });
      // 206: adjustments posted, a Tax Roll Summary row did not re-total. See the note on
      // juneResaleCreateAdjustments above.
      else if (juneResaleCreateAdjustmentsForWinningBid.statusCode === 206) dispatch('flashError', juneResaleCreateAdjustmentsForWinningBid.message || 'Adjustments were created, but at least one Tax Roll Summary row did not update.', { root: true });
      else dispatch('flashError', juneResaleCreateAdjustmentsForWinningBid.message || 'There was a problem while creating adjustments', { root: true });
      return juneResaleCreateAdjustmentsForWinningBid;
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem while creating adjustments', { root: true });
    }
    return {};
  },
  async getJuneResaleCountBasedOnSaleYear({ commit, dispatch },
    { itemToSent }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.mutate({
        mutation: gql`mutation getJuneResaleCountBasedOnSaleYear($itemToSent: createJuneResaleInputType!)  {
          getJuneResaleCountBasedOnSaleYear(upsert: $itemToSent) {
                totalRecords,
              }
            }`,
        variables: {
          itemToSent,
        },
      });
      if (results.data && results.data.getJuneResaleCountBasedOnSaleYear) {
        return results.data.getJuneResaleCountBasedOnSaleYear.totalRecords;
      }
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem getting june resale count based on sale year', { root: true });
    }
    return {};
  },
  async addANewRecordToJuneResale({ commit, dispatch },
    { itemToSent }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.mutate({
        mutation: gql`mutation addANewRecordToJuneResale($itemToSent: createJuneResaleInputType!)  {
          addANewRecordToJuneResale(upsert: $itemToSent) {
                statusCode,
              }
            }`,
        variables: {
          itemToSent,
        },
      });
      const { addANewRecordToJuneResale } = results.data;
      if (addANewRecordToJuneResale.statusCode === 200) dispatch('flashSuccess', 'A new June Resale record added Successfully', { root: true });
      else if (addANewRecordToJuneResale.statusCode === 201) dispatch('flashInfo', 'Record not found with the combination of tax year and tax id', { root: true });
      else if (addANewRecordToJuneResale.statusCode === 203) dispatch('flashWarn', 'A new June Resale record already exists', { root: true });
      return addANewRecordToJuneResale;
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem adding june resale records', { root: true });
    }
    return {};
  },
  async addDetailToJuneResaleRecords({ commit, dispatch },
    { itemToSent }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.mutate({
        mutation: gql`mutation addDetailToJuneResaleRecords($itemToSent: createJuneResaleInputType!)  {
          addDetailToJuneResaleRecords(upsert: $itemToSent) {
                statusCode,
              }
            }`,
        variables: {
          itemToSent,
        },
      });
      const { addDetailToJuneResaleRecords } = results.data;
      if (addDetailToJuneResaleRecords.statusCode === 200) dispatch('flashSuccess', 'Detail added to June Resale record Successfully', { root: true });
      else if (addDetailToJuneResaleRecords.statusCode === 201) dispatch('flashInfo', 'Record not found with the combination of tax year and tax id', { root: true });
      else if (addDetailToJuneResaleRecords.statusCode === 203) dispatch('flashWarn', 'Detail already exists in June Resale record', { root: true });
      return addDetailToJuneResaleRecords;
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem adding detail to june resale records', { root: true });
    }
    return {};
  },
  async pullCurrentDetailsToJuneResale({ commit, dispatch },
    { itemToSent }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.mutate({
        mutation: gql`mutation pullCurrentDetailsToJuneResale($itemToSent: createJuneResaleInputType!)  {
          pullCurrentDetailsToJuneResale(upsert: $itemToSent) {
                statusCode,
              }
            }`,
        variables: {
          itemToSent,
        },
      });
      const { pullCurrentDetailsToJuneResale } = results.data;
      if (pullCurrentDetailsToJuneResale.statusCode === 200) dispatch('flashSuccess', 'A new June Resale record updated Successfully', { root: true });
      return pullCurrentDetailsToJuneResale;
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem updating june resale records', { root: true });
    }
    return {};
  },
  async pullAllRecordsForCurrentJuneResale({ commit, dispatch },
    { itemToSent }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.mutate({
        mutation: gql`mutation pullAllRecordsForCurrentJuneResale($itemToSent: createJuneResaleInputType!)  {
          pullAllRecordsForCurrentJuneResale(upsert: $itemToSent) {
                statusCode,
              }
            }`,
        variables: {
          itemToSent,
        },
      });
      const { pullAllRecordsForCurrentJuneResale } = results.data;
      if (pullAllRecordsForCurrentJuneResale.statusCode === 200) dispatch('flashSuccess', 'All records for current June Resale list pulled Successfully', { root: true });
      // a 201 used to be silent, so a part-written run looked like nothing happened
      else if (pullAllRecordsForCurrentJuneResale.statusCode === 201) dispatch('flashInfo', 'The June Resale pull did not complete - check the server log and re-run', { root: true });
      return pullAllRecordsForCurrentJuneResale;
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem updating june resale records', { root: true });
    }
    return {};
  },
  async removePaidRecordsFromJuneResale({ commit, dispatch },
    { itemToSent }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.mutate({
        mutation: gql`mutation removePaidRecordsFromJuneResale($itemToSent: createJuneResaleInputType!)  {
          removePaidRecordsFromJuneResale(upsert: $itemToSent) {
                statusCode,
              }
            }`,
        variables: {
          itemToSent,
        },
      });
      const { removePaidRecordsFromJuneResale } = results.data;
      if (removePaidRecordsFromJuneResale.statusCode === 200) dispatch('flashSuccess', 'A new June Resale record updated Successfully', { root: true });
      // a 201 used to be silent, so a part-written run looked like nothing happened
      else if (removePaidRecordsFromJuneResale.statusCode === 201) dispatch('flashInfo', 'Removing paid records did not complete - check the server log and re-run', { root: true });
      return removePaidRecordsFromJuneResale;
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem when removing paid records from june resale records', { root: true });
    }
    return {};
  },
  async disableWebPaymentsJuneResale({ commit, dispatch },
    { itemToSent }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.mutate({
        mutation: gql`mutation disableWebPaymentsJuneResale($itemToSent: createJuneResaleInputType!)  {
          disableWebPaymentsJuneResale(upsert: $itemToSent) {
                statusCode,
              }
            }`,
        variables: {
          itemToSent,
        },
      });
      const { disableWebPaymentsJuneResale } = results.data;
      if (disableWebPaymentsJuneResale.statusCode === 200) dispatch('flashSuccess', 'Web payments disabled for June Resale records Successfully', { root: true });
      // a 201 used to be silent, so a part-written run looked like nothing happened
      else if (disableWebPaymentsJuneResale.statusCode === 201) dispatch('flashInfo', 'Disabling web payments did not complete - check the server log and re-run', { root: true });
      return disableWebPaymentsJuneResale;
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem when disabling web payments for june resale records', { root: true });
    }
    return {};
  },
};

export default juneResaleActions;
